import { useEffect, useState } from 'react';
import SponsershipHistoryWrapper from './Styles/SponsershipHistoryWrapper';
import API from '../../api/axios';
import { APP_URLS } from '../../api/url';
import { toast } from 'react-toastify';
import { APIError, showUserTypeBadge } from '../../core/utils';
import RecordCount from '../../assets/SharedComponents/RecordCount/RecordCount';
import { Tooltip } from '@mui/material';
import { FaFilterIcon } from '../../assets/Images/icon';
import SubsidiaryFilter from '../../assets/SharedComponents/Filters/SubsidiaryFilter';
import { ThreeDots } from 'react-loader-spinner';
import NoRecord from '../../assets/SharedComponents/Table/NoRecord';
import moment from 'moment';
import Pagination from '../../assets/SharedComponents/Pagination';
import StaticFilter from '../../assets/SharedComponents/Filters/StaticFilter';
import { confirmAlert } from 'react-confirm-alert';

const StatusList = [{
  name: 'All',
  value: ''
}, {
  name: 'Used',
  value: 1
}, {
  name: 'Not used',
  value: 0
}]

const SponsershipHistory = () => {

  const [sponsershipHistory, _sponsershipHistory] = useState([])

  const [pagintation, _pagintation] = useState({
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    RecordsPerPage: 10,
  });

  const [filters, _filters] = useState({
    sub_id: "",
    used: "",
    trashed: false
  });

  const [isLoading, _isLoading] = useState({
    history: false,
    extractReport: false,
    statusUpdateLoader: false
  })

  const [resetFilters, _resetFilters] = useState(false);
  const [refetchApi, _refetchApi] = useState()


  useEffect(() => {
    getSponsershipHistory();
  }, [pagintation.currentPage, pagintation.RecordsPerPage, filters, refetchApi]);

  const getFilters = () => {

    const params = new URLSearchParams({
      page: pagintation.currentPage,
      per_page: pagintation.RecordsPerPage,
    });

    if (filters.sub_id) params.append("filter[subsidiary_id]", filters.sub_id);
    if (filters.used) params.append("filter[used]", filters.used);
    if (filters.trashed !== undefined) params.append("with_trashed", filters.trashed ? 1 : 0);

    return params.toString();
  }

  const handleLoader = (key, value) => {
    _isLoading((prev) => {
      return {
        ...prev,
        [key]: value
      }
    })
  }


  const getSponsershipHistory = () => {
    handleLoader('history', true)
    API.get(`${APP_URLS.SPONSERSHIP_HISTORY}?${getFilters()}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _sponsershipHistory(resp.data.data);
          _pagintation((prev) => ({
            ...prev,
            totalPages: resp.data.last_page,
            totalRecords: resp.data.total,
          }));
        } else {
          toast.error(resp.message, { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch((error) => {
        let error_message = APIError(error);
        toast.error(error_message, { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => {
        handleLoader('history', false)
      });
  };

  const handleFilterChange = (key, value) => {
    _filters((prev) => ({ ...prev, [key]: value }));
    _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0 }));
  };

  const clearFilter = () => {
    _filters({
      sub_id: "",
      used: "",
      trashed: false
    });
    _pagintation((prev) => ({ ...prev, currentPage: 1, totalPages: 0, RecordsPerPage: 10 }));
    _resetFilters(true)
  };

  const handleUpdateStatus = (history) => {

    if (isLoading.statusUpdateLoader) return;

    const newStatus = !history.used;

    confirmAlert({
      title: "Confirm Update",
      message: `Are you sure you want to update the status?`,
      closeOnEscape: true,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            handleLoader('statusUpdateLoader', true)
            API.patch(`${APP_URLS.SPONSERSHIP_HISTORY}/${history.id}`, {
              used: newStatus
            })
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  toast.success(
                    'Status has been updated successfully.',
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    }
                  );
                  _sponsershipHistory((prevHistories) => {
                    return prevHistories.map((v) =>
                      v.id === history.id
                        ? { ...v, used: newStatus }
                        : v
                    );
                  });
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch(function (error) {
                toast.error(APIError(error), {
                  position: toast.POSITION.TOP_RIGHT,
                });
              }).finally(() => {
                handleLoader('statusUpdateLoader', false)
              })
          },
        },
        {
          label: "No",
        },
      ],
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
    });
  };

  return (
    <SponsershipHistoryWrapper>
      <h1>Sponsership History</h1>
      <div className='filters'>
        <SubsidiaryFilter
          filters={resetFilters}
          _filters={_resetFilters}
          setSub={(val) => handleFilterChange('sub_id', val)}
          sub={filters.sub_id}
        />
        <StaticFilter
          placeholder="Status"
          data={StatusList}
          handleChange={(e) => { handleFilterChange('used', e.target.value) }}
          value={filters.used}
        />
        <RecordCount
          onSearchClick={(search) => _pagintation((prev) => ({ ...prev, RecordsPerPage: search }))}
          val={pagintation.RecordsPerPage}
          key={pagintation.RecordsPerPage}
        />
        <Tooltip title="Clear Filter" placement="bottom">
          <FaFilterIcon className="filter-icon" role="button" onClick={clearFilter} />
        </Tooltip>
      </div>
      <div className='record-summary'>
        <div>
          Total Records : <b>{pagintation.totalRecords}</b>
        </div>
        <div>
          <input
            type="checkbox"
            checked={!filters.trashed}
            onChange={() => {
              handleFilterChange('trashed', !filters.trashed)
            }}
          />
          <span className="ms-2">Hide Deleted Data</span>
        </div>
      </div>
      <div className='tableContainer'>
        <table className='auctionTable'>
          <thead className='tableHead'>
            <tr className='table-row'>
              <th>ID</th>
              <th className='user-links'>Subsidiary</th>
              <th>Country</th>
              <th>
                Package Name
              </th>
              <th>
                Package Amount
              </th>
              <th>
                Purchase At
              </th>
              <th>Used Status</th>
            </tr>
          </thead>
          {isLoading.history ?
            <div className="d-flex justify-content-center three-dot">
              <ThreeDots
                height="150"
                width="150"
                radius="9"
                color="#637df4"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div> :
            <tbody>
              {sponsershipHistory.length > 0 ?
                sponsershipHistory.map((history) => {
                  const subsididary = history.subsidiary
                  return (
                    <tr className={`table-row ${history.deleted_at ? 'deletedRow' : ''}`} key={history.id}>
                      <td>{history.id}</td>
                      <td className='user-links'>
                        <a
                          href={`/company-details/${subsididary.id}`}
                          className="link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <b>
                            {subsididary.name}
                            {showUserTypeBadge('subsidiary')}
                          </b>
                        </a>
                      </td>
                      <td>
                        {subsididary?.limited_address?.flag_thumbnail &&
                          <img
                            src={subsididary.limited_address.flag_thumbnail}
                            alt=""
                            className="countryflag"
                            title={subsididary.limited_address.country}
                          />
                        }
                      </td>
                      <td>
                        {history?.price?.plan?.name ?? ''}
                      </td>
                      <td>
                        € {((history?.price?.unit_amount ?? 0) / 100).toFixed(2)}
                      </td>
                      <td>
                        {moment(history.created_at)
                          .tz("Europe/Amsterdam")
                          .format("DD-MM-YYYY HH:mm")}
                      </td>
                      <td>
                        {!history.deleted_at &&
                          <input
                            type="checkbox"
                            checked={history.used}
                            onChange={() => handleUpdateStatus(history)}
                            disabled={isLoading.statusUpdateLoader}
                          />
                        }
                      </td>
                    </tr>
                  )
                }) :
                <NoRecord />
              }
            </tbody>
          }
        </table>
      </div>

      {/* Pagination */}
      {pagintation.totalPages > 1 && (
        <Pagination
          totalPages={pagintation.totalPages}
          page={pagintation.currentPage}
          key={pagintation.totalPages}
          onPageClick={(page) => _pagintation((prev) => ({ ...prev, currentPage: page + 1 }))}
        />
      )}
    </SponsershipHistoryWrapper>
  )
}

export default SponsershipHistory